<div class="{{ isMobileDevice ? 'd-block' : 'd-flex' }} align-items-center justify-content-between mb-2">
  <h2 class="f-16">Edit Task</h2>
  <div class="{{ isMobileDevice ? 'd-block' : 'd-flex' }}">
    <button
      class="_cancel-btn mr-2 {{ isMobileDevice ? 'my-2' : '' }}"
      (click)="lmService.is_new_task = false; closeAddTask(true)"
      *ngIf="lmService.tab_levels?.length === 1">
      Cancel
    </button>
    <button type="button" class="_primary-btn mr-2 {{ isMobileDevice ? 'mb-2' : '' }}" (click)="isShowChild = !isShowChild" *ngIf="!tasks?.parent_id">
      Create SubTask
    </button>
    <button type="button" class="_outline-btn bg-white mr-2 {{ isMobileDevice ? 'mb-2' : '' }}" (click)="duplicateTask()">
      <i class="pi pi-plus mr-2 f-10"></i> Copy Task
    </button>
    <button class="mr-2 _outline-btn btn-sm" [disabled]="submit_btn_disabled" *ngIf="isMobileDevice" (click)="onSubmit('onlyUpdate')">Save</button>
    <ng-container *ngIf="user_permission.includes('task.edit') || user_role == 'master admin'">
      <div class="d-flex align-items-center ml-auto savebuttons">
        <button class="mr-2 _outline-btn btn-sm" [disabled]="submit_btn_disabled" *ngIf="!isMobileDevice" (click)="onSubmit('onlyUpdate')">
          Save
        </button>
        <button class="_primary-btn btn-sm" [disabled]="submit_btn_disabled" (click)="onSubmit('save')" *ngIf="lmService.tab_levels?.length === 1">
          Save & Close
        </button>
      </div>
    </ng-container>
    <img [src]="common_images?.automation_icon" class="ml-2 process-setting" *ngIf="!isMobileDevice" (click)="GetListingWorkflowProcesses()" />
  </div>
</div>

<div class="pb-2 pt-2">
  <p class="form-error font-weight-bold cursor-pointer" *ngIf="numOfNotValidFields > 0" (click)="notDisplayRequiredMessage = false">
    You have {{ numOfNotValidFields }} notifications. Select to view.
  </p>
  <div class="error-message" [ngClass]="{ 'd-none': notDisplayRequiredMessage }">
    <ul>
      <li class="pb-1 cursor-pointer" *ngFor="let message of requiredErrorMessages" (click)="ActivateTabIndexByError(message.field)">
        {{ message?.message | capitalizephrase }}
      </li>
    </ul>
  </div>
</div>

<div class="ic-editor-body w-100">
  <form [formGroup]="editTaskForm" class="w-100" #editFormElement>
    <div class="row">
      <div class="col-sm-6 mb-2">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group mb-2">
              <label for="title">Title <span title="Required">*</span></label>
              <input
                type="text"
                class="site-input"
                [ngClass]="{ '_input-error': editTaskForm.controls['title'].hasError('required') }"
                formControlName="title" />
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group mb-2" *ngIf="jobTypes">
              <label for="role">Task Type <span title="Required">*</span></label>
              <ng-select
                formControlName="job_type_id"
                [items]="jobTypes"
                bindLabel="name"
                bindValue="_id"
                [searchable]="true"
                (change)="onJobType()"
                [clearable]="false"
                [ngClass]="{
                  '_input-error': editTaskForm.controls['job_type_id'].hasError('required') || !isValidJobTypeId(),
                }"
                placeholder="Select Job Type">
              </ng-select>
            </div>
          </div>

          <div class="col-lg-6 mb-2">
            <div class="form-group input-mb" *ngIf="taskStatuses">
              <label for="role">Task Status <span title="Required">*</span></label>
              <ng-select
                formControlName="task_status_id"
                [items]="taskStatuses"
                bindLabel="name"
                bindValue="_id"
                [searchable]="true"
                placeholder="Select Status"
                [ngClass]="{ '_input-error': editTaskForm.controls['task_status_id'].hasError('required') }">
              </ng-select>
            </div>
          </div>

          <div class="col-sm-12 input-mb" *ngIf="showLeads">
            <div class="create-task-dropdown mb-2">
              <label for="assign" (click)="openLead()">Lead</label>
              <ng-select
                [items]="leads"
                bindLabel="full_name"
                bindValue="_id"
                [searchable]="true"
                formControlName="lead_id"
                placeholder="Select Lead"
                [clearable]="true"
                class="task-contact"
                [ngClass]="{ '_input-error': editTaskForm.controls['lead_id'].hasError('required') && submitted }">
                <ng-template ng-label-tmp let-item="item">
                  <div class="d-flex align-items-center cursor-pointer">
                    <p class="ng-value-label" style="z-index: 999" (click)="openLead()">{{ item.full_name }}</p>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <span>{{ item.full_name }}</span>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label class="module">Select Module</label>
              <ng-select
                formControlName="property_project_type"
                [items]="dropdown_options"
                bindLabel="name"
                bindValue="value"
                [searchable]="true"
                placeholder="Select Module">
              </ng-select>
            </div>
          </div>

          <div class="col-sm-6" *ngIf="priorities">
            <div class="form-group mb-0">
              <div class="d-flex align-items-center">
                <p>Priority</p>
                <p class="ypm-text-light f-10 ml-1 mt-1">Assign a priority for your task.</p>
              </div>
              <div class="{{ isMobileDevice ? 'd-block' : 'd-flex' }} align-items-start">
                <div class="form-check py-2 px-1 pb-0" *ngFor="let priority of priorities">
                  <div class="p-field-radiobutton d-flex align-items-center">
                    <p-radioButton name="priority_id" [value]="priority._id" formControlName="priority_id"></p-radioButton>
                    <label for="priority_id" class="pl-2 f-10">{{ priority.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="create-task-dropdown col-lg-6"
            *ngIf="
              editTaskForm.controls['property_project_type'].value == 'properties' && editTaskForm.controls['property_project_type'].value != 'other'
            ">
            <label for="assign">Property</label>
            <re-multiselect
              [module]="'property'"
              [truncate]="13"
              [selected_ids]="this.editTaskForm.controls['properties_id'].value"
              (onUpdate)="onUpdateMSelect($event, 'properties_id')"
              [placeholder]="'Select Property'"
              [isCreateNew]="false"
              [style]="{ width: '100%' }">
            </re-multiselect>
          </div>

          <div
            class="col-sm-6"
            *ngIf="
              editTaskForm.controls['property_project_type'].value == 'property' && editTaskForm.controls['property_project_type'].value != 'other'
            ">
            <label for="assign">Listing</label>
            <re-multiselect
              [module]="'listings'"
              [truncate]="13"
              [selected_ids]="this.editTaskForm.controls['property_id'].value"
              (onUpdate)="onUpdateMSelect($event, 'property_id')"
              [placeholder]="'Select Listing'"
              [isCreateNew]="false"
              [style]="{ width: '100%' }">
            </re-multiselect>
          </div>

          <div
            class="col-sm-6"
            *ngIf="
              editTaskForm.controls['property_project_type'].value == 'contact' && editTaskForm.controls['property_project_type'].value != 'other'
            ">
            <label for="contact">Contact</label>
            <re-multiselect
              [module]="'contacts'"
              [truncate]="13"
              [selected_ids]="editTaskForm.controls['contact_id'].value"
              (onUpdate)="onUpdateMSelect($event, 'contact_id')"
              [placeholder]="'Select Contact'"
              [style]="{ width: '100%' }"
              (editRecord)="editRecord($event)"
              [isEmail]="true">
            </re-multiselect>
          </div>

          <div
            class="col-sm-4"
            *ngIf="
              showProject &&
              editTaskForm.controls['property_project_type'].value == 'project' &&
              editTaskForm.controls['property_project_type'].value != 'other'
            ">
            <label for="project">Project </label>
            <re-multiselect
              [module]="'projects'"
              [truncate]="13"
              [isMultiple]="false"
              [selected_ids]="editTaskForm.controls['project_id'].value?.toString()"
              (onUpdate)="onUpdateMSelect($event, 'project_id')"
              [placeholder]="'Select Project'"
              [style]="{ width: '100%' }">
            </re-multiselect>
          </div>

          <div
            class="create-task-dropdown col-sm-4"
            *ngIf="
              apartments?.length > 0 &&
              editTaskForm.controls['property_project_type'].value == 'project' &&
              editTaskForm.controls['property_project_type'].value != 'other'
            ">
            <label for="apartment">Lot</label>
            <ng-select
              formControlName="apartment_id"
              [items]="apartments"
              bindLabel="lot_name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Select Lot"
              [ngClass]="{ '_input-error': editTaskForm.controls['apartment_id'].hasError('required') && submitted }">
            </ng-select>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="activity-wrap mt-3">
            <label (click)="showTab = 'comment'" class="mb-1">Notes</label>
            <div class="form-group mb-2">
              <textarea
                class="site-input mb-2"
                [ngClass]="{ '_input-error': editTaskForm.controls['description'].hasError('required') }"
                formControlName="description"
                cols="1"
                rows="4"
                placeholder="Send a note to the Assignee"></textarea>
            </div>
            <ul class="task-activity-list">
              <li *ngFor="let log of logList">
                <div class="task-activity-thumbnail">
                  <img src="{{ log.user.photo_thumb === '' ? common_images?.profile_image : log.user.photo_thumb }}" alt="" />
                </div>
                <div class="task-activity-content">
                  <div class="small mb-1">{{ log.time_ago }}</div>
                  <h5 class="mb-1 _fw-600">{{ log.user.first_name + ' ' + log.user.last_name }}</h5>
                  <p class="mb-1 _fw-600">
                    {{ log.heading }} : {{ log.old }} <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    {{ log.new }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-sm-12 input-mt">
          <div class="form-group mb-2">
            <label for="additionalcoments" class="mb-1">Additional Comments</label>
            <textarea
              name="additionalcoments"
              [(ngModel)]="comments"
              [ngModelOptions]="{ standalone: true }"
              class="site-input block-tab"
              cols="20"
              rows="4"
              placeholder="Send comments to the Assignee/Creator">
            </textarea>
            <div class="text-right">
              <button class="_outline-btn mt-2" [class.disabled]="commentSubmit || !comments" (click)="saveComments()">Send Comment</button>
            </div>
          </div>
          <p class="f-14 _fw-600 mb-2">Comments</p>
          <div class="commentList" *ngIf="commentList">
            <div *ngFor="let comment of commentList">
              <p class="f-12 mb-1 _fw-600">{{ comment.comments }}</p>
              <div class="comments-meta mb-2">
                <p class="f-10">by {{ comment.user.data.first_name }}</p>
                <p class="small f-10">{{ comment.time_ago }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 input-mt">
          <div class="form-group mb-2">
            <input type="file" #logoInput id="fileInput" (change)="onLogoSelect($event)" [hidden]="1" accept=".svg,image/*" multiple="true" />
            <button type="button" class="btn btn-dark" (click)="logoInput.click()"><i class="pi pi-plus mr-2"></i> Add Files</button>
          </div>
          <div class="fonts-list logo" *ngIf="tasks?.attachments?.data?.length > 0">
            <div class="s-font mb-2 position-relative" *ngFor="let logo of tasks?.attachments?.data" style="max-width: 70px">
              <i class="pi pi-times" (click)="deleteLogo(logo)"></i>
              <img
                *ngIf="logo?.file?.includes('https://remmi-xm.s3.ap-southeast-2.amazonaws.com/')"
                [src]="logo?.file"
                alt="logo.file"
                class="img-fluid" />
              <img
                *ngIf="!logo?.file?.includes('https://remmi-xm.s3.ap-southeast-2.amazonaws.com/')"
                [src]="S3Path + logo?.file"
                alt="logo.name"
                class="img-fluid" />
            </div>
          </div>
          <div class="fonts-list logo" *ngIf="logoUrl?.length > 0">
            <div class="s-font mb-2 position-relative" *ngFor="let logo of logoUrl; let i = index" style="max-width: 70px">
              <i class="pi pi-times" (click)="clearFileInput(); logos.splice(i, 1); logoUrl.splice(i, 1)"></i>
              <img [src]="logo" alt="" class="img-fluid" />
            </div>
          </div>
        </div>

        <div class="col-sm-12 input-mt">
          <div class="form-group mb-2">
            <label>Checklist</label>
            <div class="d-flex align-items-center mx-0">
              <input
                type="text"
                [(ngModel)]="newItem"
                class="mr-2 site-input"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Add item in checklist"
                style="margin-top: 2px" />
              <button class="_cancel-btn px-4 br-50" [disabled]="newItem === ''" (click)="addCheckListItem()">
                {{ checkItemToEdit !== null ? 'Edit' : 'Add' }}
              </button>
            </div>
            <ul class="col-12 checklist-list" cdkDropList (cdkDropListDropped)="drop($event)">
              <li *ngFor="let item of checkList; let i = index" cdkDrag class="mb-2">
                <div class="p-field-radiobutton d-flex align-items-center">
                  <p-radioButton name="sale_type" [value]="item" [(ngModel)]="newItem" (click)="checkItemToEdit = i; newItem = item"> </p-radioButton>
                  <label for="sale_type" class="pl-2 f-10">{{ item }}</label>
                </div>
                <div class="checklist-actions position-relative d-flex">
                  <span class="x-icon icon-drag"></span>
                  <span class="pi pi-times close-icon" (click)="checkList.splice(i, 1); checkItemToEdit = null"></span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-sm-6 mb-2">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group mb-2">
              <label for="duedate">Select Date <span title="Required">*</span></label>
              <div class="w-100 right-aligned">
                <p-calendar
                  placeholder="dd/mm/yy"
                  [firstDayOfWeek]="1"
                  formControlName="due_date"
                  (onSelect)="formatDates($event, 'due_date')"
                  [minDate]="minDate"
                  dateFormat="dd/mm/yy"
                  [ngClass]="{ invalidCalendarField: editTaskForm.controls['due_date'].hasError('required') }"></p-calendar>
              </div>
            </div>
          </div>
          <div class="col-sm-6 input-mt">
            <div class="task_time mb-2">
              <label for="role">Time</label>
              <ng-select formControlName="task_time" [items]="timer_options" placeholder="Select Task Time" [searchable]="true"></ng-select>
            </div>
          </div>
          <div class="col-sm-4 taskSpandStatus">
            <div class="form-group mb-2">
              <label for="role">Reminder</label>
              <ng-select
                formControlName="reminder"
                [items]="reminder_options"
                [ngClass]="{ '_input-error': editTaskForm.controls['reminder'].hasError('required') && submitted }"
                [searchable]="true"
                placeholder="Select Reminder">
              </ng-select>
            </div>
          </div>
          <div class="col-sm-3 col-md-4 taskSpandStatus mt-4">
            <div class="form-group mb-2">
              <div class="d-flex align-items-center">
                <p-checkbox
                  [binary]="true"
                  inputId="binary"
                  [ngClass]="{ '_input-error': editTaskForm.controls['isRecurring'].hasError('required') && submitted }"
                  formControlName="isRecurring"></p-checkbox>
                <p class="pl-1 resurcing">Recurring Task</p>
              </div>
            </div>
          </div>
          <div class="col-sm-4 taskSpandStatus mt-4">
            <div class="form-group mb-2">
              <div class="d-flex align-items-center">
                <p-checkbox
                  [binary]="true"
                  inputId="binary"
                  [ngClass]="{
                    '_input-error': editTaskForm.controls['SaveToGoogleCalendar'].hasError('required') && submitted,
                  }"
                  formControlName="SaveToGoogleCalendar"></p-checkbox>
                <p class="pl-1" tooltipPosition="top" pTooltip="Create task on attached calendars of selected staff">Sync Calendar</p>
              </div>
            </div>
          </div>
          <div class="col-sm-6" *ngIf="editTaskForm.controls['isRecurring'].value">
            <div class="form-group mb-2">
              <label class="invisible">invisible</label>
              <ng-select
                formControlName="recurringType"
                [items]="[{ name: 'Weekly' }, { name: 'Monthly' }, { name: 'Yearly' }]"
                bindLabel="name"
                bindValue="name"
                [searchable]="true"
                placeholder="Select Recurring Type">
              </ng-select>
            </div>
          </div>
          <div class="col-sm-6" *ngIf="editTaskForm.controls['recurringType'].value && editTaskForm.controls['isRecurring'].value">
            <div class="form-group mb-2">
              <label for="duedate">End Date</label>
              <div class="w-100 right-aligned">
                <p-calendar
                  placeholder="dd/mm/yy"
                  [firstDayOfWeek]="1"
                  dateFormat="dd/mm/yy"
                  (onSelect)="formatDates($event, 'recurringEnds')"
                  formControlName="recurringEnds">
                </p-calendar>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-4">
              <div class="form-group mb-2">
                <label for="assign">Staff <span title="Required">*</span></label>
                <ng-select
                  [items]="originalAssigns"
                  formControlName="assignedUsers"
                  [multiple]="true"
                  [searchable]="true"
                  bindLabel="full_name"
                  bindValue="_id"
                  placeholder="Select Assignee"
                  class="_selectMultiple"
                  [ngClass]="{ '_input-error': editTaskForm.controls['assignedUsers'].hasError('required') }">
                  <ng-template ng-option-tmp let-item="item">
                    <p>{{ item?.email ? item.full_name + ' (' + item.email + ')' : item.full_name }}</p>
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item">
                    <div class="d-flex align-items-center cursor-pointer px-1">
                      <i class="pi pi-times-circle" (click)="clearStaff(item?._id, 'staff')"></i>
                      <p class="ng-value-label ml-1" (click)="openRightModal(item, 'staff')">{{ item.full_name }}</p>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-sm-4 mb-2">
              <label for="assign">Team</label>
              <re-multiselect
                [module]="'teams'"
                [truncate]="13"
                [selected_ids]="this.editTaskForm.controls['assignedTeams'].value"
                (onUpdate)="onUpdateMSelect($event, 'assignedTeams')"
                [placeholder]="'Select Team'"
                [isCreateNew]="false"
                [style]="{ width: '100%' }">
              </re-multiselect>
            </div>
            <div class="col-sm-4 mb-2" *ngIf="tasks?.parent_id">
              <label for="assign">Parent Task</label>
              <ng-select
                formControlName="parent_id"
                [items]="task_list"
                bindLabel="title"
                bindValue="_id"
                [searchable]="true"
                [multiple]="false"
                placeholder="Parent Task"
                [clearable]="false">
              </ng-select>
            </div>
          </div>
        </div>

        <div class="mt-3 row" *ngIf="isShowChild">
          <div class="col-sm-9">
            <input
              type="text"
              class="site-input"
              placeholder="Enter Task Title"
              [(ngModel)]="child_task_title"
              [ngModelOptions]="{ standalone: true }" />
          </div>
          <div class="col-sm-3">
            <button type="button" class="_cancel-btn mr-2" (click)="isShowChild = false; child_task_title = null">Cancel</button>
            <button type="button" class="_outline-btn" (click)="saveChildTask()" [class.disabled]="submittedBtn">Save</button>
          </div>
        </div>

        <p class="my-3 f-16 _fw-600" *ngIf="child_task_list?.length > 0 && !editTaskForm.controls['parent_id'].value">Sub Task</p>
        <ng-container *ngIf="child_task_list?.length > 0 && !editTaskForm.controls['parent_id'].value">
          <div class="listing-details position-relative">
            <div class="scrol_" (scroll)="onTaskScroll($event)" #taskScrollableElement>
              <i class="pi pi-arrow-up" (click)="scrollTaskToTop()" *ngIf="taskScrollTop > 50"></i>
              <p-table styleClass="pagination-dropdown" scrollWidth="100%" dataKey="_id" [value]="child_task_list" [rows]="taskRows">
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="property_project_type">
                      <div class="d-flex align-items-center justify-content-between p-ai-center">
                        <p>Association</p>
                        <p-sortIcon field="property_project_type"></p-sortIcon>
                      </div>
                    </th>
                    <th pSortableColumn="title">
                      <div class="d-flex align-items-center justify-content-between p-ai-center">
                        <p>Title</p>
                        <p-sortIcon field="title"></p-sortIcon>
                      </div>
                    </th>
                    <th pSortableColumn="priority_id">
                      <div class="d-flex align-items-center justify-content-between p-ai-center">
                        <p>Priority</p>
                        <p-sortIcon field="priority_id"></p-sortIcon>
                      </div>
                    </th>
                    <th pSortableColumn="task_status_id">
                      <div class="d-flex align-items-center justify-content-between p-ai-center">
                        <p>Status</p>
                        <p-sortIcon field="task_status_id"></p-sortIcon>
                      </div>
                    </th>
                    <th pSortableColumn="due_date">
                      <div class="d-flex align-items-center justify-content-between p-ai-center">
                        <p>Due Date</p>
                        <p-sortIcon field="due_date"></p-sortIcon>
                      </div>
                    </th>
                    <th pSortableColumn="assignToUsers">
                      <div class="d-flex align-items-center justify-content-between p-ai-center">
                        <p>Assignee</p>
                        <p-sortIcon field="assignToUsers"></p-sortIcon>
                      </div>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-task>
                  <tr class="cursor-pointer" (click)="openRightModal(task, 'edit_task')">
                    <td>
                      <div class="d-flex align-items-center">
                        <span *ngIf="task?.properties_id?.length > 0" (click)="task.isOpen = !task.isOpen">
                          <ng-container *ngIf="task?.isOpen; else more_pro">
                            <ng-container *ngFor="let properties of task?.properties_id?.slice(0, 1); let i = index">
                              <span class="badge badge-remmi-theme">{{ properties?.property_address }}</span>
                            </ng-container>
                          </ng-container>
                          <ng-template #more_pro>
                            <ng-container *ngFor="let properties of task?.properties_id; let i = index">
                              <span class="badge badge-remmi-theme">{{ properties?.property_address }}</span>
                            </ng-container>
                          </ng-template>
                        </span>
                        <span *ngIf="task?.contact_id?.length > 0" (click)="task.isOpen = !task.isOpen">
                          <ng-container *ngIf="task?.isOpen; else more_contact">
                            <ng-container *ngFor="let contact of task?.contact_id?.slice(0, 1); let i = index">
                              <span class="badge badge-remmi-theme">{{ contact?.full_name }}</span>
                            </ng-container>
                          </ng-container>
                          <ng-template #more_contact>
                            <ng-container *ngFor="let contact of task?.contact_id; let i = index">
                              <span class="badge badge-remmi-theme">{{ contact?.full_name }}</span>
                            </ng-container>
                          </ng-template>
                        </span>
                        <span *ngIf="task?.project_id?.length > 0" (click)="task.isOpen = !task.isOpen">
                          <ng-container *ngIf="task?.isOpen; else more_project">
                            <ng-container *ngFor="let project of task?.project_id?.slice(0, 1); let i = index">
                              <span class="badge badge-remmi-theme">{{ project?.Project_Name }}</span>
                            </ng-container>
                          </ng-container>
                          <ng-template #more_project>
                            <ng-container *ngFor="let project of task?.project_id; let i = index">
                              <span class="badge badge-remmi-theme">{{ project?.Project_Name }}</span>
                            </ng-container>
                          </ng-template>
                        </span>
                        <span *ngIf="task?.property_id?.length > 0" (click)="task.isOpen = !task.isOpen">
                          <ng-container *ngIf="task?.isOpen; else more_listing">
                            <ng-container *ngFor="let listing of task?.property_id?.slice(0, 1); let i = index">
                              <span class="badge badge-remmi-theme">{{ listing?.property_address }}</span>
                            </ng-container>
                          </ng-container>
                          <ng-template #more_listing>
                            <ng-container *ngFor="let listing of task?.property_id; let i = index">
                              <span class="badge badge-remmi-theme">{{ listing?.property_address }}</span>
                            </ng-container>
                          </ng-template>
                        </span>
                      </div>
                    </td>
                    <td class="cursor-pointer text-captilize">
                      <p>{{ task?.title }}</p>
                    </td>
                    <td class="cursor-pointer text-captilize">
                      <p>{{ task?.priority_id }}</p>
                    </td>
                    <td class="cursor-pointer text-captilize" [ngStyle]="{ color: task?.task_status_id[0]?.color }">
                      <p>{{ task?.task_status_id[0]?.name }}</p>
                    </td>
                    <td class="cursor-pointer text-captilize">
                      <p>{{ task?.due_date | date: 'dd/MM/yy' }}</p>
                    </td>
                    <td class="cursor-pointer text-captilize overflow-hidden">
                      <span *ngIf="task?.assignToUsers?.data?.length > 0" (click)="task.isOpen = !task.isOpen">
                        <ng-container *ngIf="task?.isOpen; else moreCon">
                          <ng-container *ngFor="let assign of task?.assignToUsers?.data?.slice(0, 1); let i = index">
                            <span class="badge badge-remmi-theme">{{ assign.full_name }}</span>
                          </ng-container>
                        </ng-container>
                        <ng-template #moreCon>
                          <ng-container *ngFor="let assign of task?.assignToUsers?.data; let i = index">
                            <span class="badge badge-remmi-theme">{{ assign.full_name }}</span>
                          </ng-container>
                        </ng-template>
                      </span>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="6">No record found.</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          <div class="mt-5">
            <p>{{ 'Records: ' + child_task_list?.length }}</p>
          </div>
        </ng-container>
        <p class="my-3 f-16 _fw-600">Notes</p>
        <div class="task-notes">
          <app-notes [moduleId]="this.tasks || { _id: this.editId, property_address: editTaskForm.controls['title'].value }"></app-notes>
        </div>
      </div>

      <div class="row pr-0">
        <div class="col-lg-2 mt-3" *ngIf="editTaskForm.controls['start_date']?.value">
          <p>Created: {{ editTaskForm.controls['start_date'].value | date: 'dd/MM/yy' }}</p>
        </div>
        <div class="col-lg-10 pr-0 {{ isMobileDevice ? 'mt-2' : '' }} ">
          <div class="form-group d-flex align-items-center pr-16">
            <ng-container *ngIf="user_permission.includes('task.edit') || user_role == 'master admin'">
              <div class="d-flex align-items-center ml-auto savebuttons">
                <button
                  class="_cancel-btn mr-2"
                  (click)="lmService.is_new_task = false; closeAddTask(true)"
                  *ngIf="lmService.tab_levels?.length === 1">
                  Cancel
                </button>
                <button class="mr-2 _outline-btn btn-sm" [disabled]="submit_btn_disabled" (click)="onSubmit('onlyUpdate')">Save</button>
                <button
                  class="{{ isMobileDevice ? 'mt-2' : '' }} _primary-btn btn-sm"
                  [disabled]="submit_btn_disabled"
                  (click)="onSubmit('save')"
                  *ngIf="lmService.tab_levels?.length === 1">
                  Save & Close
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
